import isBrowserContext from "helpers/isBrowserContext";

export default (): string => {
    if (isBrowserContext()) {
        return window.location.origin;
    }
    else {
        if (globalThis.origin) {
            return globalThis.origin as string;
        }
        else {
            throw Error("Server origin is null");
        }
    }
};